import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ModelloContabileDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';

@Injectable()
export class ModelloContabileApiClient extends BaseCRUDApiClient<ModelloContabileDto> {
  baseUrl = this.config.apiEndpoint + '/modello-contabile';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
